import { PrintableDocument, PrinterConfig } from "./types";
import {
  renderInvoiceToHtml,
  renderGiftCardToHtml,
  renderGiftCardReceiptToHtml,
  renderTransactionAccountReceiptToHtml,
  renderGiftCardTransactionAccountToHtml,
  renderClosureToHtml,
} from "./html-renderers";
import {
  renderInvoiceToEscPos,
  renderGiftCardToEscPos,
  renderGiftCardReceiptToEscPos,
  renderTransactionAccountReceiptToEscPos,
  renderGiftCardTransactionAccountToEscPos,
  renderClosureToEscPos,
} from "./escpos-renderers";

export async function renderDocumentToHtml(
  doc: PrintableDocument,
  printerConfig: PrinterConfig,
  additionalSettings?: {
    receiptHeader?: string;
    receiptFooter?: string;
  },
): Promise<string> {
  switch (doc.type) {
    case "invoice":
      return await renderInvoiceToHtml({
        ...doc,
        printerConfig,
        additionalSettings,
      });
    case "gift-card":
      return renderGiftCardToHtml({ giftCardData: doc, printerConfig });
    case "gift-card-receipt":
      return renderGiftCardReceiptToHtml({ receiptData: doc, printerConfig });
    case "transaction-account":
      return await renderTransactionAccountReceiptToHtml({
        doc,
        printerConfig,
      });
    case "gift-card-transaction-account":
      return renderGiftCardTransactionAccountToHtml({ doc, printerConfig });
    case "closure":
      return renderClosureToHtml({ closureData: doc, printerConfig });
  }
}

export async function renderDocumentToEscPos(
  doc: PrintableDocument,
  printerConfig: PrinterConfig,
  additionalSettings?: {
    receiptHeader?: string;
    receiptFooter?: string;
  },
): Promise<string[]> {
  if (!printerConfig) {
    throw new Error("Printer config is required");
  }

  const rawCommands = await (async () => {
    switch (doc.type) {
      case "invoice":
        return renderInvoiceToEscPos({
          ...doc,
          additionalSettings,
          printerConfig,
        });
      case "gift-card":
        return renderGiftCardToEscPos({ doc, printerConfig });
      case "gift-card-receipt":
        return renderGiftCardReceiptToEscPos({ doc, printerConfig });
      case "transaction-account":
        return renderTransactionAccountReceiptToEscPos({ doc, printerConfig });
      case "gift-card-transaction-account":
        return renderGiftCardTransactionAccountToEscPos({ doc, printerConfig });
      case "closure":
        return renderClosureToEscPos({ doc, printerConfig });
    }
  })();

  const singleString = String.fromCharCode(...rawCommands);
  return [singleString];
}
